import Modal from '../Modal';
import TopicsList from './TopicsList.jsx';

const TopicsModal = () => {
  return Modal({
    component: <TopicsList />,
    width: '394px',
    padding: '24px',
  });
};

export default TopicsModal;
